import { Link } from "react-router-dom";
import { collections } from "@/mocks/movies";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CollectionSection() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Curated Lists"
        title="影视专题合集"
        description="由编辑整理的片单，按情绪与题材归类，适合不知道看什么的时候随手翻一翻。"
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
        {collections.map((collection, index) => (
          <Link
            key={collection.id}
            to={`/category?genre=${encodeURIComponent(collection.genre)}`}
            className="group relative block h-[230px] overflow-hidden rounded-lg bg-primary-950 md:h-[300px]"
          >
            <img
              src={collection.image}
              alt={`${collection.title}专题`}
              title={`${collection.title} 影视专题片单`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/45 to-primary-950/10" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <span className="font-label text-[11px] tracking-[0.2em] text-accent-400">
                VOL.{String(index + 1).padStart(2, "0")} · {collection.count} 部
              </span>
              <h3 className="mt-2 text-lg font-bold tracking-tight text-background-50 md:text-xl">{collection.title}</h3>
              <p className="mt-1 text-xs text-primary-200">{collection.subtitle}</p>
              <p className="mt-2 max-w-xs text-xs leading-6 text-primary-300 opacity-0 transition-opacity duration-300 group-hover:opacity-100 md:line-clamp-2">
                {collection.description}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-400">
                查看片单
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}